import React from "react";
import "./SchoolCard.css";

const SchoolCard = (props) => {
  return (
    <div className="school-card p-3 d-flex flex-column flex-md-row align-items-center align-items-md-start col-10 col-lg-6">
      <div className="col-6 col-lg-4">
        <img src={props.image} alt="Škola" className="p-3 circular-image" />
      </div>
      <div className="d-flex flex-column w-100">
        <h4 className="text-center">{props.schoolName}</h4>
        <div className="row w-100 m-2 d-flex align-items-center">
          <div className="col-2 ps-1">
            <img
              src="../images/phone.svg"
              alt="Telefon"
              className="contact-icon"
            />
          </div>
          <div className="col-10 left-border">
            <div>Telefon </div>
            <div>
              <b>{props.phone}</b>
            </div>
          </div>
        </div>

        <div className="row w-100 m-2 d-flex align-items-center">
          <div className="col-2 ps-1">
            <img
              src="../images/open-exit-door.svg"
              alt="Místnost"
              className="contact-icon"
            />
          </div>
          <div className="col-10 left-border">
            <div>Adresa </div>
            <div>
              <b>
                {props.address_first_line}, {props.address_second_line}
              </b>
            </div>
          </div>
        </div>

        <div className="row w-100 m-2 d-flex align-items-center">
          <div className="col-2 ps-1">
            <img src="../images/mail.svg" alt="Mail" className="contact-icon" />
          </div>
          <div className="col-10 left-border">
            <div>Email </div>
            <div>
              <b>{props.email}</b>
            </div>
          </div>
        </div>
        {props.dataBox && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img
                src="../images/data-box.svg"
                alt="Datová schránka"
                className="contact-icon"
              />
            </div>
            <div className="col-10 left-border">
              <div>Datová schránka </div>
              <div>
                <b>{props.dataBox}</b>
              </div>
            </div>
          </div>
        )}
        {props.emailroom && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img
                src="../images/epodatelna.svg"
                alt="Datová schránka"
                className="contact-icon"
              />
            </div>
            <div className="col-10 left-border">
              <div>E-podatelna </div>
              <div>
                <b>{props.emailroom}</b>
              </div>
            </div>
          </div>
        )}
        {props.bankAccount && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img
                src="../images/bank.svg"
                alt="Banka"
                className="contact-icon"
              />
            </div>
            <div className="col-10 left-border">
              <div>Bankovní účet </div>
              <div>
                <b>{props.bankAccount}</b>
              </div>
            </div>
          </div>
        )}
        {props.ic && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img src="../images/ico.svg" alt="DIC" className="contact-icon" />
            </div>
            <div className="col-10 left-border">
              <div>IČO </div>
              <div>
                <b>{props.ic}</b>
              </div>
            </div>
          </div>
        )}

        {props.dic && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img src="../images/dic.svg" alt="DIC" className="contact-icon" />
            </div>
            <div className="col-10 left-border">
              <div>DIČ </div>
              <div>
                <b>{props.dic}</b>
              </div>
            </div>
          </div>
        )}
        {props.facebook && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img
                src="../images/facebook.svg"
                alt="fb"
                className="contact-icon"
              />
            </div>
            <div className="col-10 left-border">
              <div>Facebook </div>
              <div>
                <a href={props.facebook}>odkaz na Facebook</a>
              </div>
            </div>
          </div>
        )}
        {props.founder && (
          <div className="row w-100 m-2 d-flex align-items-center">
            <div className="col-2 ps-1">
              <img
                src="../images/founder.svg"
                alt="Datová schránka"
                className="contact-icon"
              />
            </div>
            <div className="col-10 left-border">
              <div>Zřizovatel </div>
              <div>
                <b>{props.founder}</b>
              </div>
            </div>
          </div>
        )}
        {props.openingHours && props.openingHours.length > 0 && (
          <table className="mt-3">
            <tbody>
              {props.openingHours.map((otvDoba) => (
                //React fragment misto <></> protoze tomu nejde pridelit key
                <React.Fragment key={otvDoba.id}>
                  <tr>
                    <td className="p-2">{otvDoba.day}</td>
                    <td>
                      {otvDoba.from.substring(0, 5)} -{" "}
                      {otvDoba.to.substring(0, 5)}
                    </td>
                  </tr>

                  {/* volitelny druhy cas */}
                  {otvDoba.from_second && otvDoba.to_second && (
                    <tr>
                      <td></td>
                      <td>
                        {otvDoba.from_second.substring(0, 5)} -{" "}
                        {otvDoba.to_second.substring(0, 5)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
export default SchoolCard;

